
import React, { useEffect, useMemo } from "react";

import useTranslation from "../../Hooks/UseTranslation";

import Kanban from "../../Components/Kanban/Kanban";

import DiamondSvg from "../../Components/SvgImages/Diamond";

import './TasksGroupByState.scss'

type Props = {
  height: number;
  tasks: any;
  filters: any
  teams: any;

  onSelectTask: (task_id: string) => void;
}

const TaskGroupByState = (props: Props) => {

  const { t } = useTranslation()

  const getAllTasksFromList = (list: any) => {

    const tasks: any[] = []

    list.forEach((item: any) => {

      if (item.type === 'task') {

        tasks.push(item.task)
      } else {

        const subTasks = getAllTasksFromList(item.group.items)

        if (subTasks.length)
          tasks.push(...subTasks)
      }
    })

    return tasks
  }

  const groupedByState = useMemo(() => {

    const tasks: any = {
      milestone: [],
      activa: [],
      'activa-atrasada': [],
      liberada: [],
      atrasada: [],
      pendiente: [],
      completada: [],
    }

    const allTasks = getAllTasksFromList(props.tasks)

    allTasks.map((task: any) => {

      if (typeof task.status === 'undefined')
        return

      if (task.type === 'hito') {

        tasks.milestone.push(task)
      }

      if (task.type !== 'hito' && task.type !== 'reunion') {

        tasks[task.status].push(task)
      }
    })

    return tasks
  }, [getAllTasksFromList, props.tasks, props.filters])

  const columns = [
    {
      icon: (<DiamondSvg width={15} height={15} />),
      title: t('TASK_TYPES:Milestone'),
      className: 'milestone',
      tasks: groupedByState['milestone']
    },
    {
      icon: (<span className='icon-estado_activa' />),
      title: t('TASKS_GROUP_BY_STATUS:ActiveStatus'),
      className: 'activa',
      tasks: groupedByState['activa']
    },
    {
      icon: (<span className='icon-estado_activa_atrasada' />),
      title: t('TASKS_GROUP_BY_STATUS:ActiveOverdueStatus'),
      className: 'activa-atrasada',
      tasks: groupedByState['activa-atrasada']
    },
    {
      icon: (<span className='icon-estado_liberada' />),
      title: t('TASKS_GROUP_BY_STATUS:ReleasedStatus'),
      className: 'liberada',
      tasks: groupedByState['liberada']
    },
    {
      icon: (<span className='icon-estado_atrasada text-color-atrasada' />),
      title: t('TASKS_GROUP_BY_STATUS:OverdueStatus'),
      className: 'atrasada',
      tasks: groupedByState['atrasada']
    },
    {
      icon: (<span className='icon-estado_pendiente' />),
      title: t('TASKS_GROUP_BY_STATUS:PendingStatus'),
      className: 'pendiente',
      tasks: groupedByState['pendiente']
    },
    {
      icon: (<span className='icon-estado_completada' />),
      title: t('TASKS_GROUP_BY_STATUS:CompletedStatus'),
      className: 'completada',
      tasks: groupedByState['completada']
    }
  ]

  const filteredColumns = useMemo(() => {

    const states = props.filters.state ? props.filters.state.split(',') : []

    const types = props.filters.type ? props.filters.type.split(',') : []

    const isMilestoneInFilters = types.includes('hito')

    return columns.filter((column: any) => {

      if (types.length > 0 && column.className === 'milestone' && isMilestoneInFilters) {

        return true
      }

      if (states.includes(column.className === 'activa-atrasada' ? 'activa_atrasada' : column.className)) {

        console.log('column', column)

        return true
      }

      if (states.length === 0) {

        return true
      }

      return false
    })
  }, [t, props.filters, groupedByState])

  return (
    <Kanban
      height={props.height}
      columns={filteredColumns}
      onSelectTask={props.onSelectTask}
    />
  )
}

export default TaskGroupByState;
